import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, Children, cloneElement } from 'react';
import clsx from 'clsx';
import { IconChevronRightLarge } from '../../../../foundation/icons/IconChevronRightLarge/index.js';
import { useBreadCrumbsStyles } from '../styles/index.js';
import { BreadCrumbsSizesXL } from '../sizes/index.js';
import { computeResponsiveness } from '../../../../foundation/responsive/helpers/index.js';

const BreadCrumbs = forwardRef(({ size = BreadCrumbsSizesXL, className, children, }, ref) => {
    const childrenCount = Children.count(children);
    const sizes = computeResponsiveness(size);
    const styles = useBreadCrumbsStyles({ sizes });
    return (jsx("ul", { className: clsx(styles.root, className), "data-testid": "breadcrumbs", ref: ref, children: Children.map(children, ((child, index) => (jsxs("li", { className: clsx(styles.item, {
                [styles.itemHasIcon]: index !== (childrenCount - 1),
            }), children: [cloneElement(child, { size }), index !== (childrenCount - 1) && jsx(IconChevronRightLarge, { className: styles.icon })] }, index.toString())))) }));
});
BreadCrumbs.displayName = 'BreadCrumbs';

export { BreadCrumbs };
